import React from 'react';
import PropTypes from 'prop-types';
import {
  statusBusyDoor,
  statusReservedDoor,
  statusOnline,
  translate,
} from '../../../../utils/Common';
import { LuAlertCircle } from 'react-icons/lu';
import styles from './PlatformQuickInfo.module.css';

const PlatformQuickInfo = ({ platform }) => (
  <div className={styles.container}>
    <div className={styles.sections}>
        <div className={styles.section}>
          <h6 className={styles.sectionTitle}>{translate('global.doors')}</h6>
          <div className={styles.stats}>
            <div className={styles.statRow}>
              <span className={styles.statLabel}>{statusBusyDoor} {translate('global.occupiedDoors')}</span>
              <span className={styles.statValue}>{platform?.occupiedDoors ?? '0'}</span>
            </div>
            <div className={styles.statRow}>
              <span className={styles.statLabel}>{statusReservedDoor} {translate('global.reservedDoors')}</span>
              <span className={styles.statValue}>{platform?.reservedDoors ?? '0'}</span>
            </div>
            <div className={styles.statRow}>
              <span className={styles.statLabel}>{statusOnline} {translate('global.availableDoors')}</span>
              <span className={styles.statValue}>{platform?.availableDoors ?? '0'}</span>
            </div>
            <div className={`${styles.statRow} ${styles.statRowBold}`}>
              <span className={styles.statLabel}>{translate('global.totalDoors')}</span>
              <span className={styles.statValue}>{platform?.totalDoors ?? '0'}</span>
            </div>
          </div>
        </div>
        <div className={styles.section}>
          <h6 className={styles.sectionTitle}>{translate('global.availability')}</h6>
          <div className={styles.stats}>
            <div className={styles.statRow}>
              <span className={styles.statLabel}>{translate('global.smallDoors')}</span>
              <span className={styles.statValue}>{platform?.availableSmallDoors ?? '0'}</span>
            </div>
            <div className={styles.statRow}>
              <span className={styles.statLabel}>{translate('global.mediumDoors')}</span>
              <span className={styles.statValue}>{platform?.availableMediumDoors ?? '0'}</span>
            </div>
            <div className={styles.statRow}>
              <span className={styles.statLabel}>{translate('global.largeDoors')}</span>
              <span className={styles.statValue}>{platform?.availableLargeDoors ?? '0'}</span>
            </div>
            <div className={styles.statRow}>
              <span className={styles.statLabel}>{translate('global.xlDoors')}</span>
              <span className={styles.statValue}>{platform?.availableXlDoors ?? '0'}</span>
            </div>
            <div className={`${styles.statRow} ${styles.statRowBold}`}>
              <span className={styles.statLabel}>
                <LuAlertCircle size={14} className={styles.inactiveIcon} />
                {translate('global.inactiveDoors')}
              </span>
              <span className={styles.statValue}>{platform?.inactivedDoors ?? '0'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

PlatformQuickInfo.propTypes = {
  platform: PropTypes.object.isRequired,
};

export default PlatformQuickInfo;
